import {User, UserManager, WebStorageStateStore} from "oidc-client-ts";
import React from "react";

export interface IAuthService {
    getUser(): Promise<User | null>;

    login(params: any): Promise<void>;

    logout(): Promise<void>;

    renewToken(): Promise<User | null>;

    signinCallback(): Promise<User>;
}

export interface GumaProps {
    authority: string,
    clientId: string,
    clientSecret: string,
    redirectUri: string
}

export class AuthService implements IAuthService {
    private _userManager: UserManager;

    constructor(gumaProps: GumaProps) {
        const settings = {
            authority: gumaProps.authority,
            client_id: gumaProps.clientId,
            client_secret: gumaProps.clientSecret,
            redirect_uri: gumaProps.redirectUri,
            silent_redirect_uri: `${gumaProps.redirectUri}silent-renew.html`,
            post_logout_redirect_uri: `${gumaProps.redirectUri}`,
            response_type: "code",
            scope: "openid profile email",
            userStore: new WebStorageStateStore({store: window.localStorage}),
        };
        this._userManager = new UserManager(settings);

        this._userManager.events.addAccessTokenExpired(() => console.log("token expired"));
    }

    public async getUser(): Promise<User | null> {
        return await this._userManager.getUser();
    }

    public async login(params: any): Promise<void> {
        return new Promise<void>((resolve) => {
            const {code, state} = params;
            if (!code && !state) {
                this._userManager.signinRedirect().catch((error) => console.error(error));
            } else {
                this._userManager
                    .signinCallback()
                    .then((user: User | void) => {
                        this._userManager
                            .storeUser(user as User)
                            .then(() => this._userManager.clearStaleState())
                            .finally(() => resolve());
                    })
                    .catch((error) => {
                        console.error(`login error: ${error}`);
                    });
            }
        });
    }

    public async renewToken(): Promise<User | null> {
        return await this._userManager.signinSilent();
    }

    public async logout(): Promise<void> {
        return await this._userManager.signoutRedirect();
    }

    public async signinCallback(): Promise<User> {
        return await this._userManager.signinRedirectCallback();
    }
}

export const AuthContext = React.createContext<any>(undefined);
